<template>
    <div>
        <div class="grid" :class="[...gridClasses]">
            <ImageLinkCard
                v-for="(subCat, i) in subCategories || []"
                :key="i"
                class="w-full"
                :title="subCat.category_name"
                :media="subCat.image"
            />
        </div>
    </div>
</template>
<script lang="ts" setup>
    import ImageLinkCard from "@/components/ImageLinkCard.vue";
    import { computed } from "vue";

    const props = defineProps({
        images: {
            type: Array<{ mapped_subcategory: string; media: string }>,
            default: []
        },
        cards_per_row: {
            type: String,
            default: "3",
            validator: (value: string) =>
                ["1", "2", "3", "4", "5"].includes(value)
        },
        gap_between_cards: { type: Boolean, default: true },
        builderContext: {
            type: Object,
            default() {
                return {};
            }
        }
    });

    const gridClasses = computed(() => {
        let classes;
        switch (props.cards_per_row) {
            case "1":
                classes = ["md:grid-cols-1"];
                break;
            case "2":
                classes = ["md:grid-cols-2"];
                break;
            case "3":
                classes = ["md:grid-cols-3"];
                break;
            case "4":
                classes = ["md:grid-cols-4"];
                break;
            case "5":
                classes = ["md:grid-cols-5"];
                break;
            default:
                classes = ["md:grid-cols-3"];
                break;
        }

        classes.push("grid-cols-2");

        if (props.gap_between_cards) {
            classes = [...classes, "gap-4", "mb-4"];
        } else {
            classes.push("gap-0");
        }
        return classes;
    });

    const subCategoryImages = computed(() => {
        return props.images.reduce(
            (obj, img) => ({ ...obj, [img.mapped_subcategory]: img.media }),
            {}
        );
    });

    const categoryData = computed(() => {
        return props.builderContext?.content?.data?.category ?? {};
    });

    const subCategories = computed(() => {
        let arr = categoryData.value.child_category.map((subCat) => ({
            ...subCat,
            image: subCategoryImages.value[subCat.category_name]
        }));
        return arr;
    });
</script>
